import { Pipe, PipeTransform } from '@angular/core';
import { WorkOrderItemGroup, WorkOrderItemGroupType } from '../../domains/work-order-item-group.selectors';

@Pipe({ name: 'typeIsIn' })
export class TypeIsInPipe implements PipeTransform {
  transform(group: WorkOrderItemGroup, ...types: WorkOrderItemGroupType[]): boolean {
    return types?.some(type => group?.type === type) ?? false;
  }
}
